<template>
    <div class="imgModuleBox">
        <p class="title">{{title}}</p>
        <div class="imgBox">
            <img v-if="!upload" v-for="(item,index) in img" :random="random" :name="name" :src="img" @click="showImg(index)" />
            <van-uploader v-if="upload" :disabled='disabled' :deletable='deletable' :after-read="afterRead"
                :before-read="beforeRead" v-model="fileList" multiple='true' :max-count="ImgMaxCount" :max-size="10485760"
                :oversize="onOversize" :before-delete="_delete" />
        </div>
    </div>
</template>

<script>
    import * as imageConversion from 'image-conversion'
    import {
        ImagePreview,
        Uploader
    } from 'vant'
    export default {
        name: 'ImgModule',
        props: {
            img: Array,
            name: String,
            title: {
                type: String | null,
                default: '图片'
            },
            upload: {
                type: Boolean,
                default: false
            },
            deletable: Boolean,
            disabled: {
                type: Boolean,
                default: false
            },
            ImgMaxCount: { //图片默认上传数量
                type: Number,
                default: 10
            },
            random: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                fileList: this.img ? this.img : [],
            }
        },
        mounted() {
            this.$Bus.$on('YSRKDelete', res => {
                this.fileList = res;
            })
        },
        methods: {
            showImg(index) {
                ImagePreview({
                    images: this.img,
                    startPosition: index,
                    swipeDuration: 10000,
                    closeOnPopstate: true,
                })
            },
            afterRead(file) {
                if (file instanceof Array) {
                    this.loadDataDefault(file);
                } else {
                    file.random = this.$getRandomNumber(5);
                    this.imageConversion(file).then(fileResult => {
                        this.$emit('afterRead', fileResult);
                        this.$Toast.clear();
                    })
                }
            },
            beforeRead(file, detail) {
                if (file instanceof Array & this.fileList.length + file.length > this.ImgMaxCount) {
                    this.$Toast("图片数量不能大于" + this.ImgMaxCount + '!');
                    return false;
                }
                this.$Toast({
                    message: '预加载中！',
                    duration: 0
                });
                return true;
            },
            onOversize(file) {
                console.log(file, '图片超过大小');
                this.$Toast('图片大小不能超过 10mb', );
            },
            _delete(item) {
                if (this.random) this.fileList.splice(this.fileList.findIndex(x => x.random === item.random), 1); //开启随机数，即：立即删除不走api
                this.$emit('deleteImg', item);
            },
            imageConversion(FileObject) { //图片压缩
                return new Promise((resolve, reject) => {
                    imageConversion.compressAccurately(FileObject.file, 2400).then(res => {
                        this.blobToBase64(res).then(res => {
                            FileObject.content = res;
                            resolve(FileObject);
                        })
                    })
                })
            },
            blobToBase64(blob) { //Blob转Base64
                return new Promise((resolve, reject) => {
                    const fileReader = new FileReader();
                    fileReader.onload = (e) => {
                        resolve(e.target.result);
                    };
                    fileReader.readAsDataURL(blob);
                    fileReader.onerror = () => {
                        reject(new Error('blobToBase64 error'));
                    };
                });
            },
            loadDataDefault(FileArray) {
                for (let i = 0; i < FileArray.length; i++) {
                    // if(this.random){//赋予随机数
                    //     FileArray[i].random=this.$getRandomNumber(5);
                    // }
                    FileArray[i].random = this.$getRandomNumber(5);
                    if (FileArray[i].file.size / 1024 / 1024 > 0.21) {
                        this.imageConversion(FileArray[i]).then(fileResult => {
                            FileArray[i] = fileResult;
                            if (i === FileArray.length - 1) {
                                this.$Toast.clear();
                                this.$emit('afterRead', FileArray);
                            }
                        })
                    } else {
                        if (i === FileArray.length - 1) {
                            this.$Toast.clear();
                            this.$emit('afterRead', FileArray);
                        }
                    }
                }
            },
            rotateImg(img, direction, canvas) { // 对图片旋转处理
                // alert(img);
                // 最小与最大旋转方向，图片旋转4次后回到原方向
                var minStep = 0
                var maxStep = 3
                // var img = document.getElementById(pid);
                if (img == null) return
                // img的高度和宽度不能在img元素隐藏后获取，否则会出错
                var height = img.height
                var width = img.width
                // var step = img.getAttribute('step');
                var step = 2
                if (step == null) {
                    step = minStep
                }
                if (direction === 'right') {
                    step++
                    // 旋转到原位置，即超过最大值
                    step > maxStep && (step = minStep)
                } else {
                    step--
                    step < minStep && (step = maxStep)
                }
                // 旋转角度以弧度值为参数
                var degree = step * 90 * Math.PI / 180
                var ctx = canvas.getContext('2d')
                switch (step) {
                    case 0:
                        canvas.width = width
                        canvas.height = height
                        ctx.drawImage(img, 0, 0)
                        break
                    case 1:
                        canvas.width = height
                        canvas.height = width
                        ctx.rotate(degree)
                        ctx.drawImage(img, 0, -height)
                        break
                    case 2:
                        canvas.width = width
                        canvas.height = height
                        ctx.rotate(degree)
                        ctx.drawImage(img, -width, -height)
                        break
                    case 3:
                        canvas.width = height
                        canvas.height = width
                        ctx.rotate(degree)
                        ctx.drawImage(img, -width, 0)
                        break
                }
            }
        },
        components: {
            [Uploader.name]: Uploader
        },
        // ,watch:{
        //     fileList(){
        //         console.log(this.fileList);
        //     }
        // }
    }
</script>

<style scoped lang="scss">
    .imgModuleBox {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 38px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .title {
            color: $TEXT-DARK-COLOR;
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 30px;
        }

        .imgBox {
            display: flex;
            flex-wrap: wrap;

            img {
                width: 106px;
                height: 106px;
                margin-right: 26px;
                border-radius: 4px;
                margin-bottom: 15px;

                &:nth-child(5n) {
                    margin-right: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/imgModule/imgModule.vue